import {
    GET_DASHBOARD_DETAILS,
    GET_DASHBOARD_DETAILS_SUCCESS,
    GET_DASHBOARD_DETAILS_FAILURE,
    GET_NOTIFICATION_LIST,
    GET_NOTIFICATION_LIST_SUCCESS,
    GET_NOTIFICATION_LIST_FAILURE,
    READ_NOTIFICATION_LIST,
    READ_NOTIFICATION_LIST_FAILURE,
    READ_NOTIFICATION_LIST_SUCCESS,
    CLEAR_NOTIFICATION_LIST,
    CLEAR_NOTIFICATION_LIST_SUCCESS,
    CLEAR_NOTIFICATION_LIST_FAILURE,
    GET_INTERVIEW_DETAILS,
    GET_INTERVIEW_DETAILS_SUCCESS,
    GET_INTERVIEW_DETAILS_FAILURE,
    RESEND_EMAIL,
    RESEND_EMAIL_SUCCESS,
    RESEND_EMAIL_FAILURE,
    CHANGE_PASSWORD,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    LOGOUT_USER_FAILURE,
    GET_PLANS_AND_PRICING,
    GET_PLANS_AND_PRICING_SUCCESS,
    GET_PLANS_AND_PRICING_FAILURE,
    GET_BILLING_INFORMATION,
    GET_BILLING_INFORMATION_SUCCESS,
    GET_BILLING_INFORMATION_FAILURE,
    GET_POSITION_LIST,
    GET_POSITION_LIST_SUCCESS,
    GET_POSITION_LIST_FAILURE,
    GET_MANDATORY_SKILL,
    GET_MANDATORY_SKILL_SUCCESS,
    GET_MANDATORY_SKILL_FAILURE,
    FETCH_SKILLS_POSITION,
    FETCH_SKILLS_POSITION_SUCCESS,
    FETCH_SKILLS_POSITION_FAILURE,
    FETCH_SKILLS_JD,
    FETCH_SKILLS_JD_SUCCESS,
    FETCH_SKILLS_JD_FAILURE,
    POST_CHECKOUT,
    POST_CHECKOUT_SUCCESS,
    POST_CHECKOUT_FAILURE,
    FETCH_RESUME_SCORE,
    FETCH_RESUME_SCORE_SUCCESS,
    FETCH_RESUME_SCORE_FAILURE,
    GET_USER_INFORMATION,
    GET_USER_INFORMATION_SUCCESS,
    GET_USER_INFORMATION_FAILURE,
    UPDATE_USER_INFORMATION,
    UPDATE_USER_INFORMATION_SUCCESS,
    UPDATE_USER_INFORMATION_FAILURE,
    SUPPORT_REQUEST,
    SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE,
    GET_SUPPORT_TICKET,
    GET_SUPPORT_TICKET_SUCCESS,
    GET_SUPPORT_TICKET_FAILURE,
    CLOSE_SUPPORT_TICKET,
    CLOSE_SUPPORT_TICKET_SUCCESS,
    CLOSE_SUPPORT_TICKET_FAILURE,
    ORDER_UPDATE,
    ORDER_UPDATE_SUCCESS,
    ORDER_UPDATE_FAILURE,
    CREATE_INTERVIEW,
    CREATE_INTERVIEW_SUCCESS,
    CREATE_INTERVIEW_FAILURE,
    REPLICATE_INTERVIEW,
    REPLICATE_INTERVIEW_SUCCESS,
    REPLICATE_INTERVIEW_FAILURE,
    VERIFY_PAYMENT,
    VERIFY_PAYMENT_SUCCESS,
    VERIFY_PAYMENT_FAILURE,
    APPLY_COUPON,
    APPLY_COUPON_SUCCESS,
    APPLY_COUPON_FAILURE,
    GET_BANNERS,
    GET_BANNERS_SUCCESS,
    GET_BANNERS_FAILURE,
} from './types';

export const applyCoupon = (payload) => ({
    type: APPLY_COUPON,
    payload,
});
export const applyCouponSuccess = () => ({
    type: APPLY_COUPON_SUCCESS,
});
export const applyCouponFailure = () => ({
    type: APPLY_COUPON_FAILURE,
});

export const getDashboardDetails = () => ({
    type: GET_DASHBOARD_DETAILS,
});
export const getDashboardDetailsSuccess = (payload) => ({
    type: GET_DASHBOARD_DETAILS_SUCCESS,
    payload,
});
export const getDashboardDetailsFailure = () => ({
    type: GET_DASHBOARD_DETAILS_FAILURE,
});

export const getNotification = (payload) => ({
    type: GET_NOTIFICATION_LIST,
    payload,
});
export const getNotificationSuccess = (payload) => ({
    type: GET_NOTIFICATION_LIST_SUCCESS,
    payload,
});
export const getNotificationFailure = () => ({
    type: GET_NOTIFICATION_LIST_FAILURE,
});

export const readNotification = () => ({
    type: READ_NOTIFICATION_LIST,
});
export const readNotificationSuccess = () => ({
    type: READ_NOTIFICATION_LIST_SUCCESS,
});
export const readNotificationFailure = () => ({
    type: READ_NOTIFICATION_LIST_FAILURE,
});

export const clearNotification = (payload) => ({
    type: CLEAR_NOTIFICATION_LIST,
    payload,
});
export const clearNotificationSuccess = () => ({
    type: CLEAR_NOTIFICATION_LIST_SUCCESS,
});
export const clearNotificationFailure = () => ({
    type: CLEAR_NOTIFICATION_LIST_FAILURE,
});

export const getInterviewDetails = (payload) => ({
    type: GET_INTERVIEW_DETAILS,
    payload,
});
export const getInterviewDetailsSuccess = (payload) => ({
    type: GET_INTERVIEW_DETAILS_SUCCESS,
    payload,
});
export const getInterviewDetailsFailure = () => ({
    type: GET_INTERVIEW_DETAILS_FAILURE,
});

export const resendEmail = (payload) => ({
    type: RESEND_EMAIL,
    payload,
});
export const resendEmailSuccess = () => ({
    type: RESEND_EMAIL_SUCCESS,
});
export const resendEmailFailure = () => ({
    type: RESEND_EMAIL_FAILURE,
});

export const changePassword = (payload) => ({
    type: CHANGE_PASSWORD,
    payload,
});
export const changePasswordSuccess = () => ({
    type: CHANGE_PASSWORD_SUCCESS,
});
export const changePasswordFailure = () => ({
    type: CHANGE_PASSWORD_FAILURE,
});

export const logoutUser = () => ({
    type: LOGOUT_USER,
});
export const logoutUserSuccess = () => ({
    type: LOGOUT_USER_SUCCESS,
});
export const logoutUserFailure = () => ({
    type: LOGOUT_USER_FAILURE,
});

export const getPlansAndPricingList = (payload) => ({
    type: GET_PLANS_AND_PRICING,
    payload,
});
export const getPlansAndPricingListSuccess = (payload) => ({
    type: GET_PLANS_AND_PRICING_SUCCESS,
    payload,
});
export const getPlansAndPricingListFailure = () => ({
    type: GET_PLANS_AND_PRICING_FAILURE,
});

export const getBillingInformation = (payload) => ({
    type: GET_BILLING_INFORMATION,
    payload,
});
export const getBillingInformationSuccess = (payload) => ({
    type: GET_BILLING_INFORMATION_SUCCESS,
    payload,
});
export const getBillingInformationFailure = () => ({
    type: GET_BILLING_INFORMATION_FAILURE,
});

export const getPositionList = () => ({
    type: GET_POSITION_LIST,
});
export const getPositionListSuccess = (payload) => ({
    type: GET_POSITION_LIST_SUCCESS,
    payload,
});
export const getPositionListFailure = () => ({
    type: GET_POSITION_LIST_FAILURE,
});

export const getMandatorySkill = () => ({
    type: GET_MANDATORY_SKILL,
});
export const getMandatorySkillSuccess = (payload) => ({
    type: GET_MANDATORY_SKILL_SUCCESS,
    payload,
});
export const getMandatorySkillFailure = () => ({
    type: GET_MANDATORY_SKILL_FAILURE,
});

export const fetchSkillsPosition = (payload) => ({
    type: FETCH_SKILLS_POSITION,
    payload,
});
export const fetchSkillsPositionSuccess = () => ({
    type: FETCH_SKILLS_POSITION_SUCCESS,
});
export const fetchSkillsPositionFailure = () => ({
    type: FETCH_SKILLS_POSITION_FAILURE,
});

export const fetchSkillsJD = (payload) => ({
    type: FETCH_SKILLS_JD,
    payload,
});
export const fetchSkillsJDSuccess = () => ({
    type: FETCH_SKILLS_JD_SUCCESS,
});
export const fetchSkillsJDFailure = () => ({
    type: FETCH_SKILLS_JD_FAILURE,
});

export const postCheckout = (payload) => ({
    type: POST_CHECKOUT,
    payload,
});
export const postCheckoutSuccess = () => ({
    type: POST_CHECKOUT_SUCCESS,
});
export const postCheckoutFailure = () => ({
    type: POST_CHECKOUT_FAILURE,
});

export const fetchResumeScore = (payload) => ({
    type: FETCH_RESUME_SCORE,
    payload,
});
export const fetchResumeScoreSuccess = () => ({
    type: FETCH_RESUME_SCORE_SUCCESS,
});
export const fetchResumeScoreFailure = () => ({
    type: FETCH_RESUME_SCORE_FAILURE,
});

export const getUserInformation = () => ({
    type: GET_USER_INFORMATION,
});
export const getUserInformationSuccess = (payload) => ({
    type: GET_USER_INFORMATION_SUCCESS,
    payload,
});
export const getUserInformationFailure = () => ({
    type: GET_USER_INFORMATION_FAILURE,
});

export const updateUserInformation = (payload) => ({
    type: UPDATE_USER_INFORMATION,
    payload,
});
export const updateUserInformationSuccess = () => ({
    type: UPDATE_USER_INFORMATION_SUCCESS,
});
export const updateUserInformationFailure = () => ({
    type: UPDATE_USER_INFORMATION_FAILURE,
});

export const supportRequest = (payload) => ({
    type: SUPPORT_REQUEST,
    payload,
});
export const supportRequestSuccess = () => ({
    type: SUPPORT_REQUEST_SUCCESS,
});
export const supportRequestFailure = () => ({
    type: SUPPORT_REQUEST_FAILURE,
});

export const getSupportTicket = (payload) => ({
    type: GET_SUPPORT_TICKET,
    payload,
});
export const getSupportTicketSuccess = (payload) => ({
    type: GET_SUPPORT_TICKET_SUCCESS,
    payload,
});
export const getSupportTicketFailure = () => ({
    type: GET_SUPPORT_TICKET_FAILURE,
});

export const closeSupportTicket = (payload) => ({
    type: CLOSE_SUPPORT_TICKET,
    payload,
});
export const closeSupportTicketSuccess = () => ({
    type: CLOSE_SUPPORT_TICKET_SUCCESS,
});
export const closeSupportTicketFailure = () => ({
    type: CLOSE_SUPPORT_TICKET_FAILURE,
});

export const orderUpdate = (payload) => ({
    type: ORDER_UPDATE,
    payload,
});
export const orderUpdateSuccess = () => ({
    type: ORDER_UPDATE_SUCCESS,
});
export const orderUpdateFailure = () => ({
    type: ORDER_UPDATE_FAILURE,
});

export const createInterview = (payload) => ({
    type: CREATE_INTERVIEW,
    payload,
});
export const createInterviewSuccess = () => ({
    type: CREATE_INTERVIEW_SUCCESS,
});
export const createInterviewFailure = () => ({
    type: CREATE_INTERVIEW_FAILURE,
});

export const replicateInterview = (payload) => ({
    type: REPLICATE_INTERVIEW,
    payload,
});
export const replicateInterviewSuccess = () => ({
    type: REPLICATE_INTERVIEW_SUCCESS,
});
export const replicateInterviewFailure = () => ({
    type: REPLICATE_INTERVIEW_FAILURE,
});

export const verifyPayment = (payload) => ({
    type: VERIFY_PAYMENT,
    payload,
});
export const verifyPaymentSuccess = () => ({
    type: VERIFY_PAYMENT_SUCCESS,
});
export const verifyPaymentFailure = () => ({
    type: VERIFY_PAYMENT_FAILURE,
});

export const getBanners = () => ({
    type: GET_BANNERS,
});
export const getBannersSuccess = (payload) => ({
    type: GET_BANNERS_SUCCESS,
    payload,
});
export const getBannersFailure = () => ({
    type: GET_BANNERS_FAILURE,
});
